import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=09fdbdb3&scoped=true&"
import script from "./headline.vue?vue&type=script&lang=js&"
export * from "./headline.vue?vue&type=script&lang=js&"
import style0 from "./headline.vue?vue&type=style&index=0&id=09fdbdb3&lang=less&scoped=true&"
import style1 from "./headline.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fdbdb3",
  null
  
)

component.options.__file = "headline.vue"
export default component.exports